import request from "library/v1/request";

export function getFinancialArrangments(params) {
  return request({
    url: `stripe/financial_arrangement`,
    method: 'get',
    params
  })
}

export function updateFinancialArrangments(data, params) {
  return request({
    url: `stripe/financial_arrangement`,
    method: 'patch',
    data,
    params
  })
}

export function createClientSecrete(data) {
  return request({
    url: `stripe/card/payment`,
    method: 'post',
    data
  })
}

export function validateStripeAccount(data) {
  return request({
    url: `stripe/accounts/validate`,
    method: 'post',
    data
  })
}

export function getSavedPaymentMethods(params) {
  return request({
    url: `stripe/payment_methods`,
    method: 'get',
    params
  })
}

export function getMemberships(params) {
  return request({
    url: `stripe/memberships`,
    method: 'get',
    params
  })
}

export function createMembership(data) {
  return request({
    url: `stripe/memberships`,
    method: 'post',
    data
  })
}

export function cancelMembership(id, data) {
  return request({
    url: `stripe/memberships/${id}`,
    method: 'delete',
    data
  })
}

export function changeMembershipPlan(id, data) {
  return request({
    url: `stripe/memberships/${id}`,
    method: 'patch',
    data
  })
}

export function resumeMembership(id) {
  return request({
    url: `stripe/memberships/${id}/resume`,
    method: 'post'
  })
}

export function getMembershipRecovery(id) {
  return request({
    url: `stripe/memberships/${id}/payment_recovery`,
    method: 'get'
  })
}
